import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';

class CompanyProfile extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  getInitState = () => {
    return { isEditing: false };
  }

  handleCancelClick = () => {
    this.setState({ isEditing: false });
    this.props.handleCancelClick();
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  }

  handleProfileSubmit = (event) => {
    this.setState({ isEditing: false });
    this.props.handleProfileSubmit(event);
  }

  render() {
    const isEditing = this.state.isEditing;
    const user = this.props.user;
    const { t } = this.props;

    return (
      <div className="content-resvations">
        <div className="container-resvations">
          <div className="row">
            <div className="col-md-6 col-md-push-6 col-lg-4 col-lg-push-8 text-center">
              <a onClick={() => $('#chooserCompany').click()}>
                <div className="badge-wrapper">
                  <img alt={t('dashboard.profile.img_company')} src={user.company_picture} />
                </div>
              </a>
              <br />
              <h4 className="text-secondary">
                <strong>{user.company}</strong>
              </h4>
              <br />
              <div className="form-group">
                <button
                  className="btn btn-primary btn-singup"
                  onClick={this.handleEditClick}
                  type="button">
                  {t('dashboard.profile.btn_edit')}
                </button>
              </div>
            </div>
            <div className="col-md-6 col-md-pull-6 col-lg-8 col-lg-pull-4">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h4 className="panel-title">{t('dashboard.profile.heading_company')}</h4>
                </div>
                <div className="panel-body">
                  <form method="post" onSubmit={this.handleProfileSubmit}>
                    <fieldset>
                      <input
                        className="hidden"
                        id="chooserCompany"
                        onChange={this.props.handleCompanyPicture}
                        type="file" />
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="company">
                              {t('dashboard.profile.label_company')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="company"
                              onChange={this.props.handleCompanyChange}
                              placeholder={t('dashboard.profile.holder_company')}
                              type="text"
                              value={user.company} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="website">
                              {t('dashboard.profile.label_website')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="website"
                              onChange={this.props.handleWebsiteChange}
                              placeholder={t('dashboard.profile.holder_website')}
                              type="text"
                              value={user.website} />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="discount">
                              {t('dashboard.profile.label_discount')}
                            </label>
                            <textarea
                              className="form-control"
                              disabled={!isEditing}
                              id="discount"
                              onChange={this.props.handleDiscountChange}
                              placeholder={t('dashboard.profile.holder_discount')}
                              rows="3"
                              value={user.discount} />
                          </div>
                        </div>
                      </div>
                      <div className={user.member_id > 0 ? "" : "hidden"}>
                        <div className="form-group">
                          <button
                            className="btn btn-link"
                            data-target="#assistant"
                            data-toggle="collapse"
                            type="button">
                            {t('dashboard.profile.btn_assistant')}&nbsp;
                            <span className="caret" />
                          </button>
                        </div>
                        <div className="collapse" id="assistant">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label htmlFor="reply">
                                  {t('dashboard.profile.label_reply')}
                                </label>
                                <textarea
                                  className="form-control"
                                  disabled={!isEditing}
                                  id="reply"
                                  onChange={this.props.handleAssistantReply}
                                  placeholder={t('dashboard.profile.holder_reply')}
                                  rows="3"
                                  value={user.assistant_reply} />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <label htmlFor="procedure">
                                  {t('dashboard.profile.label_procedure')}
                                </label>
                                <textarea
                                  className="form-control"
                                  disabled={!isEditing}
                                  id="procedure"
                                  onChange={this.props.handleAssistantProcedure}
                                  placeholder={t('dashboard.profile.holder_procedure')}
                                  rows="3"
                                  value={user.assistant_procedure} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className={isEditing ? "hidden" : ""}>
                      </span>
                      <span className={isEditing ? "" : "hidden"}>
                        <button
                          className="btn btn-primary btn-singup"
                          type="submit">
                          {t('dashboard.profile.btn_save')}
                        </button>&nbsp;
                        <button
                          className="btn btn-outline btn-primary"
                          onClick={this.handleCancelClick}
                          type="button">
                          {t('dashboard.profile.btn_cancel')}
                        </button>
                      </span>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(CompanyProfile);



// WEBPACK FOOTER //
// ./src/dashboard/profile/CompanyProfile.js